import { ExtendImplementationDetail } from 'features/SubmitProjectProposal/components/ExtendImplementationTimeForm';

export default function DetailExtendImplementationTime() {
  return <ExtendImplementationDetail />;
}
